import { combineReducers } from 'redux';

import ComponentConfigurationSlice from 'components/modules/component-configuration/slices/ComponentConfiguration.slice';
import contentSuggestionsSlice from 'components/modules/content/slices/content-suggestions';
import customPagesSlice from 'components/modules/custom-pages/slices/custom-pages';
import htmlElementsSlice from 'components/modules/html-elements/slices';
import redirectsSlice from 'components/modules/redirect/slices/Redirect.slice';
import styleRuleConfigurationsSlice from 'components/modules/style-rules/slices/StyleRuleConfiguration.slice';
import teamsSlice from 'components/modules/team/slices/team.slice';
import themeTemplatesSlice from 'components/modules/theme-templates/slices/theme-templates';
import orderSettingsSlice from 'components/pages/ecommerce/settings/OrderSettings/OrderSettings.slice';
import business from 'reducers/business';
import contentNodes from 'reducers/content-nodes';
import eCommerce from 'reducers/ecommerce';
import notifications from 'reducers/notifications';
import products from 'reducers/products';
import user from 'reducers/user';
import inputerrors from 'reducers/validation-errors';
import website from 'reducers/website';

export default combineReducers({
  user,
  website,
  business,
  notifications,
  inputerrors,
  eCommerce,
  products,
  orderSettings: orderSettingsSlice,
  contentNodes,
  htmlElements: htmlElementsSlice,
  customPages: customPagesSlice,
  componentConfigurations: ComponentConfigurationSlice,
  teams: teamsSlice,
  redirects: redirectsSlice,
  styleRuleConfigurations: styleRuleConfigurationsSlice,
  themeTemplates: themeTemplatesSlice,
  contentSuggestions: contentSuggestionsSlice,
});
